import { Injectable, Injector } from '@angular/core';
import { Observable } from 'rxjs';

import { ParameterResult } from '@models/swagger';
import { ApiService, DefaultHttpHeaders } from '@services/api/api.service';

export interface HomeUseParams extends DefaultHttpHeaders {
  /** Unique identifier of home type */
  homeUseCode: string;
}

@Injectable()
export class HomeUseService extends ApiService {
  constructor(protected readonly injector: Injector) {
    super(injector);
  }

  /**
   * Service for obtaining home use by code
   * Service for obtaining home use by code
   * https://d2go64w4712gob.cloudfront.net/swagger/apis_trasversales/italia/api_Verti.html#/Catalog/getComeroundHomeUseById
   */
  homeUse(params: HomeUseParams): Observable<ParameterResult> {
    const pathParams = {
      homeUseCode: params.homeUseCode,
    };
    return this.get<ParameterResult>({
      suffix: `/comeround/catalog/homeUse/${pathParams.homeUseCode}`,
    });
  }
}
